// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmationDialog-module__modal--x++1b","footer":"ConfirmationDialog-module__footer--uyinH","message":"ConfirmationDialog-module__message--egAi-"};